<template>
  <div id="app" :key="$root.site" :class="'site-' + $root.site">
    <a v-if="showWidgets" href="#main" class="skip-link" @click.prevent="toMain">Перейти к содержимому</a>
    <Header v-if="$root.site !== null && $route.name !== 'selectSite' && $route.name !== 'menu'" id="header"/>
    <main id="main" tabindex="-1">
      <router-view/>
    </main>
    <Footer v-if="$root.site !== null && $route.name !== 'selectSite' && $route.name !== 'menu'" id="footer"/>

    <template v-if="showWidgets">
      <div v-if="info.whatsapp || info.telegram" class="float-soc">
        <a v-if="info.whatsapp" :href="info.whatsapp" class="float-soc__link" target="_blank" rel="nofollow" aria-label="WhatsApp">
          <img src="./assets/img/icon/soc-icon-2.svg" alt="">
        </a>
        <a v-if="info.telegram" :href="info.telegram" class="float-soc__link" target="_blank" rel="nofollow" aria-label="Telegram">
          <img src="./assets/img/icon/soc-icon-3.svg" alt="">
        </a>
      </div>

      <router-link tag="a" :to="'/' + $root.site + '/booking'" class="float-book">Забронировать</router-link>

      <div class="mobile-bar">
        <a :href="'tel:' + info.tel">Позвонить</a>
        <a v-if="info.whatsapp" :href="info.whatsapp" target="_blank" rel="nofollow">WhatsApp</a>
        <router-link :to="'/' + $root.site + '/booking'" class="mobile-bar__main">Забронировать</router-link>
      </div>
    </template>
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  import { siteInfo } from './config/sites'

  export default {
    name: "App",
    components: {
      Header,
      Footer
    },
    methods: {
      toMain () {
        const m = document.getElementById('main')
        if (m) { m.focus({ preventScroll: true }); m.scrollIntoView() }
      }
    },
    computed: {
      info () {
        return siteInfo(this.$root.site)
      },
      showWidgets () {
        return this.$route.name !== 'selectSite' && this.$route.name !== 'menu' && this.$route.name !== 'booking' && !!this.$root.site
      }
    }
  }
</script>

<style>
  @import "assets/css/style.css";
  @import "assets/css/theme.css";

  .float-soc {
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.45);
    padding: 12px;
    border-radius: 10px 0 0 10px;
    z-index: 999;
  }
  .float-soc__link { display: block; }
  .float-soc__link:not(:last-child) { margin-bottom: 12px; }

  .float-book {
    position: fixed;
    right: 18px;
    bottom: 22px;
    z-index: 998;
    background: var(--acc-ui);
    color: var(--on-acc) !important;
    padding: 15px 26px;
    border-radius: var(--r, 0);
    font: 700 13px/1 var(--body);
    letter-spacing: .08em;
    text-transform: uppercase;
    box-shadow: 0 10px 30px rgba(0, 0, 0, .28);
    cursor: pointer;
    transition: background .2s;
  }
  .float-book:hover { background: var(--acc-dark); }

  .mobile-bar { display: none; }

  @media screen and (max-width: 700px) {
    .float-book, .float-soc { display: none; }
    .mobile-bar {
      display: flex;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 998;
      background: var(--card);
      border-top: 1px solid var(--line);
      box-shadow: 0 -10px 30px rgba(0, 0, 0, .15);
    }
    .mobile-bar a {
      flex: 1 1 0;
      min-width: 0;
      white-space: nowrap;
      text-align: center;
      padding: 15px 4px;
      font: 700 12px/1.2 var(--body);
      letter-spacing: .05em;
      text-transform: uppercase;
      color: var(--fg);
    }
    /* главная кнопка шире остальных, чтобы «Забронировать» не упиралось в край на узких экранах */
    .mobile-bar .mobile-bar__main { flex: 1.5 1 0; background: var(--acc-ui); color: var(--on-acc); }
  }
</style>
